import { defineComponent as _defineComponent } from 'vue';
import { computedAsync } from "@vueuse/core";
import { computed } from "vue";
import { useDatasetPathDestination } from "@/composables/datasetPathDestination";
import { getAppRoot } from "@/onload/loadConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetAsImage',
    props: {
        historyDatasetId: null,
        path: null
    },
    setup(__props) {
        const props = __props;
        const { datasetPathDestination } = useDatasetPathDestination();
        const pathDestination = computed(() => datasetPathDestination.value(props.historyDatasetId, props.path));
        const imageUrl = computed(() => {
            if (props.path === undefined || props.path === "undefined") {
                return `${getAppRoot()}dataset/display?dataset_id=${props.historyDatasetId}`;
            }
            return pathDestination.value?.fileLink;
        });
        const isImage = computedAsync(async () => {
            if (!imageUrl.value) {
                return null;
            }
            const res = await fetch(imageUrl.value);
            const buff = await res.blob();
            return buff.type.startsWith("image/");
        }, null);
        return { __sfc: true, datasetPathDestination, props, pathDestination, imageUrl, isImage };
    }
});
